module.exports = __webpack_public_path__ + "static/media/is.2c3b9dec.svg";